/* Shared modal JS: bind open buttons, handle touch fallbacks, lock scroll, close modal */
(function(){
  if (window.__modalManagerInitialized) return;
  window.__modalManagerInitialized = true;

  function lockBodyScroll() {
    try {
      const doc = document.body;
      const scrollY = window.scrollY || window.pageYOffset || 0;
      doc.dataset.__scrollY = String(scrollY);
      // lock body in place to preserve visual scroll position
      doc.style.position = 'fixed';
      doc.style.top = `-${scrollY}px`;
      doc.style.left = '0';
      doc.style.right = '0';
      doc.style.width = '100%';
      // also prevent overscroll on html element as a precaution
      try { document.documentElement.style.overscrollBehavior = 'none'; } catch(e){}
    } catch (e) {}
  }

  function unlockBodyScroll() {
    try {
      const doc = document.body;
      const prev = parseInt(doc.dataset.__scrollY || '0', 10) || 0;
      doc.style.position = '';
      doc.style.top = '';
      doc.style.left = '';
      doc.style.right = '';
      doc.style.width = '';
      try { document.documentElement.style.overscrollBehavior = ''; } catch(e){}
      delete doc.dataset.__scrollY;
      window.scrollTo(0, prev);
    } catch (e) {}
  }

  function openModalByButton(btn) {
    if (!btn || !btn.dataset || !btn.dataset.modal) return;
    const id = btn.dataset.modal;
    const modal = document.getElementById(id);
    if (!modal) return;
    // avoid focus jump
    try { btn.blur(); } catch(e){}
    modal.classList.add('active');
    lockBodyScroll();
    pauseAllSwipers();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('active');
    unlockBodyScroll();
    resumeAllSwipers();
  }

  // Swiper pause/resume helpers (best-effort)
  function getAllSwipers() {
    const nodes = Array.from(document.querySelectorAll('.swiper'));
    const swipers = new Set();
    nodes.forEach((el)=>{ if (el.swiper) swipers.add(el.swiper); });
    // also detect potential home-hero custom props
    const hero = document.querySelector('home-hero') || document.querySelector('.home-hero');
    if (hero) { if (hero.swiper) swipers.add(hero.swiper); if (hero.info) swipers.add(hero.info); }
    return Array.from(swipers);
  }

  function stopSwiperAutoplay(swiper) {
    if (!swiper || !swiper.autoplay) return;
    const autoplay = swiper.autoplay;
    if (swiper.params && swiper.params.autoplay) swiper.params.autoplay.enabled = false;
    try { if (typeof autoplay.stop === 'function') autoplay.stop(); } catch(e){}
    try { if (typeof autoplay.pause === 'function') autoplay.pause(); } catch(e){}
    autoplay.running = false; autoplay.paused = true;
  }

  function startSwiperAutoplay(swiper) {
    if (!swiper || !swiper.autoplay) return;
    const autoplay = swiper.autoplay;
    if (swiper.params && swiper.params.autoplay) swiper.params.autoplay.enabled = true;
    try { if (typeof autoplay.start === 'function') autoplay.start(); } catch(e){}
    try { if (typeof autoplay.resume === 'function') autoplay.resume(); } catch(e){}
    autoplay.paused = false; autoplay.running = true;
  }

  function pauseAllSwipers() {
    getAllSwipers().forEach(stopSwiperAutoplay);
  }

  function resumeAllSwipers() {
    getAllSwipers().forEach(startSwiperAutoplay);
  }

  function bindOpenButtons(root=document) {
    Array.from(root.querySelectorAll('.open-modal')).forEach((btn)=>{
      if (btn.dataset && btn.dataset._modalBound) return;
      const handler = function(e){
        try{ e.preventDefault(); }catch{};
        try{ e.stopPropagation(); }catch{};
        openModalByButton(e.currentTarget || btn);
      };
      btn.addEventListener('click', handler);
      btn.addEventListener('touchend', handler, { passive: false });
      btn.dataset._modalBound = '1';
    });
  }

  function triggerIfInsideButton(x,y) {
    const buttons = document.querySelectorAll('.open-modal');
    for (const btn of buttons) {
      const rect = btn.getBoundingClientRect();
      if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
        if (btn.dataset && btn.dataset._modalTriggered) return false;
        if (!btn.dataset || !btn.dataset.modal) return false;
        btn.dataset._modalTriggered = '1';
        setTimeout(()=>{ try{ delete btn.dataset._modalTriggered; }catch{} }, 500);
        openModalByButton(btn);
        return true;
      }
    }
    return false;
  }

  function relocateModalsToBody() {
    document.querySelectorAll('.c-modal').forEach((modal) => {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    relocateModalsToBody();
    bindOpenButtons();

    const observer = new MutationObserver((mutations)=>{
      mutations.forEach((m)=>{
        if (m.addedNodes && m.addedNodes.length) {
          m.addedNodes.forEach((node)=>{
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches('.c-modal')) {
              relocateModalsToBody();
            } else if (node.matches && node.matches('.open-modal')) {
              bindOpenButtons(node.parentNode || document);
            } else if (node.querySelectorAll) {
              if (node.querySelector('.c-modal')) relocateModalsToBody();
              bindOpenButtons(node);
            }
          });
        }
      });
    });
    observer.observe(document.body, { childList:true, subtree:true });

    // pointer fallback
    if (window.PointerEvent) {
      document.addEventListener('pointerup', function(e){
        const btn = e.target && e.target.closest ? e.target.closest('.open-modal') : null;
        if (btn) { try{ e.preventDefault(); e.stopPropagation(); }catch{}; openModalByButton(btn); }
      }, { passive:false });
    } else {
      document.addEventListener('touchend', function(e){ const btn = e.target && e.target.closest ? e.target.closest('.open-modal') : null; if (btn) { try{ e.preventDefault(); e.stopPropagation(); }catch{}; openModalByButton(btn); } }, { passive:false });
      document.addEventListener('click', function(e){ const btn = e.target && e.target.closest ? e.target.closest('.open-modal') : null; if (btn) { openModalByButton(btn); } });
    }

    // coordinate-based pointerdown to capture cases where touch is intercepted
    document.addEventListener('pointerdown', function(e){
      if (e.pointerType === 'touch' || e.pointerType === 'mouse') {
        triggerIfInsideButton(e.clientX, e.clientY);
      }
    }, { passive: true });

    // close handlers
    document.addEventListener('click', function(e){
      if (e.target.classList.contains('close-modal') || e.target.classList.contains('modal-overlay')) {
        const modal = e.target.closest('.c-modal');
        if (!modal) return;
        closeModal(modal);
      }
    });

    // prevent overlay from scrolling
    document.addEventListener('touchmove', function(e){
      if (e.target.classList && e.target.classList.contains('modal-overlay')) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (e.target.closest && e.target.closest('.c-modal') && !e.target.closest('.modal-content')) {
        // touching outside modal-content inside the modal
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });

    // wheel guard for desktop inside modal-body
    document.addEventListener('wheel', function(e){
      const modalBody = e.target.closest && e.target.closest('.modal-body');
      if (!modalBody) return;
      const atTop = modalBody.scrollTop === 0;
      const atBottom = modalBody.scrollHeight - modalBody.scrollTop === modalBody.clientHeight;
      if ((atTop && e.deltaY < 0) || (atBottom && e.deltaY > 0)) {
        e.preventDefault();
      }
      e.stopPropagation();
    }, { passive: false });

  });
})();